import Kr from 'Kr/kr';
import 'KrComponent/MenuMobile';
import 'KrComponent/LayoutGallery';
import 'KrComponent/NavTo';
import 'KrComponent/SearchForm';
import 'KrComponent/HeaderFixed';
import 'KrComponent/Mansory';

import 'KrComponent/Availability';

import 'KrComponent/FrontSlider';
import 'KrComponent/PointsMap';
import 'KrComponent/AtractionMap';

import LinkClass from 'KrModule/LinkClass';

const app = new Kr.App;

app.use('link-class', LinkClass);
app.run();
